import { LoadingOutlined } from "@ant-design/icons";
import { message } from "antd";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import ModalInfo from "../../../../components/ModalInfo";
import { Sessao } from "../../../../helpers/Token";
import { downloadPlanilhaDiesel, setOpenModalPlanilhaDiesel } from "../../../../store/actions/planilhas";

import S from "./styles";

const ModalPlanilhaDiesel = (props) => {

  const planilhasReducer = useSelector((state) => state.planilhas);  
  const codigoAcessoPlanilha = Sessao('codigoAcessoPlanilha');
  const dispatch = useDispatch();

  const [isLoadingDownloadPlanilha, setLoadingDownloadPlanilha] = useState(false);

  const fecharModal = () => {
    dispatch(setOpenModalPlanilhaDiesel(false));
  }

  const clicaBaixarPlanilha = async () => {
    if(!isLoadingDownloadPlanilha){
      setLoadingDownloadPlanilha(true);
      await downloadPlanilhaDiesel();
      setLoadingDownloadPlanilha(false);
    }
    //dispatch(setOpenModalPlanilhaDiesel(false));
  }

  const clicaCopiarCodigo = () => {
    navigator.clipboard.writeText(codigoAcessoPlanilha);
    message.success("Código copiado com sucesso!");
  }

  return (
    planilhasReducer.openModalPlanilhaDiesel && (
      <ModalInfo
        onClose={fecharModal}
        title="Prezado cliente,"
        footerRender={
          <div style={{display: 'flex', alignItems: 'center'}}>
            {!isLoadingDownloadPlanilha && <S.ModalButton onClick={clicaBaixarPlanilha}>{'Baixar a planilha'}</S.ModalButton>}
            {isLoadingDownloadPlanilha && <S.LoadingButton onClick={clicaBaixarPlanilha}><LoadingOutlined /> </S.LoadingButton>}
            <S.ModalButton onClick={clicaCopiarCodigo}>{'Copiar código de acesso'}</S.ModalButton>
          </div>
        }
      >
        <S.ModalScroll>
          A e-Auditoria lançou uma nova linha de produtos voltados à Recuperação de Créditos Tributários.
          <br />
          <br />
          Trata-se da disponibilização de PLANILHAS INTELIGENTES, voltadas para oportunidades de momento, que precisam ser aproveitadas rapidamente.
          <br />
          <br />
          Para ter acesso à planilha selecionada, será necessário informar o código de acesso abaixo, que é vinculado à sua conta e-Auditoria.
          <br />
          <br />
          <span style={{fontWeight: 700}}>Seu código de acesso é:</span> <br />
          <p style={{marginLeft: 5}}>{` ${codigoAcessoPlanilha}`}</p>
          <br />
        </S.ModalScroll>
      </ModalInfo>
    )
  );
};

export default ModalPlanilhaDiesel;
